import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesSplitMain } from './modules/ui/Main';

const ServicesSplitPage = (
  <SuspensePage>
    <PagesServicesSplitMain />
  </SuspensePage>
);

export default ServicesSplitPage;
